import React, {useState, useEffect} from "react"

// components
import {Help} from "../../components/controls"

// styling
import "./TextInput.scss"

function TextInput({value, onChange, label, maxLength, multiline, field, help, validate, placeholder, mode, autocomplete, mandatory, hideValidation}) {
  // state management
  const [text, setText] = useState("")
  const [validation, setValidation] = useState({valid:true})
  
  // deal with side effects (mounting)
  useEffect(() => {
    let t = value || ""
    let v = {valid:true}
    if(validate) {
      v = validate(t)
    }

    setText(t)
    setValidation(v)

    
  }, []) // [] means mounting
  

  const _onChange = (e) => {
    let t = e.target.value
    let v = validate ? validate(t) : {valid:true}
    
    setValidation(v)
    setText(t)

    onChange({field, validation:v, value:t})
  }

  // render
  let input
  if(multiline) {
    input = <textarea onChange={_onChange} value={text} maxLength={maxLength || null} rows="4" placeholder={placeholder || ""} />
  }
  else {
    input = <input type="text" maxLength={maxLength || null} onChange={_onChange} value={text} placeholder={placeholder || ""} autoComplete={autocomplete} />
  }

  let inlineHelp = null
  if(help) {
    inlineHelp = <><span> </span><Help title={label}>{help}</Help></>
  }

  return (
    <div className="c-textinput">
      <div className="label">
        <span className={`text ${mandatory ? "mandatory":""}`}>
          {label} 
        </span>
        {inlineHelp}
      </div>
      <div className="input">
        {input}
      </div>
      <div className="info">
        <div className="validation">
          {validation.valid || hideValidation ? "" : validation.text || "*"}
        </div>
        <div className="length">
          {maxLength ? `${text.length}/${maxLength || 50}` : null}
        </div>
      </div>
    </div>
  )

  
}

export default TextInput